import { render, staticRenderFns } from "./goFloor.vue?vue&type=template&id=4143f95e&scoped=true"
import script from "./goFloor.vue?vue&type=script&lang=js"
export * from "./goFloor.vue?vue&type=script&lang=js"
import style0 from "./goFloor.vue?vue&type=style&index=0&id=4143f95e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4143f95e",
  null
  
)

export default component.exports